import Vue from "vue";
import Axios from "axios";
import store from "../store/index";
import router from "../router";

Vue.prototype.$http = Axios;

// const baseURL = 'http://localhost:5000/api';
Vue.prototype.$http.defaults.baseURL = process.env.VUE_APP_URL + "/api";
//Vue.prototype.$http.defaults.baseURL = " http://api.bezkontakta.com/api"
// Vue.prototype.$http.defaults.baseURL = "https://api.ostanikodkuce.beograd.gov.rs/api"
Vue.prototype.$http.defaults.headers.common["X-Requested-With"] =
  "XMLHttpRequest";
Vue.prototype.$http.defaults.params = {};
const token = localStorage.getItem("token");
if (token) {
  Vue.prototype.$http.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${token}`;
}

Vue.prototype.$http.interceptors.request.use(config => {
  return config;
});

Vue.prototype.$http.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    const code = error.response ? error.response.data.errorCode : null;
    switch (code) {
      case 1003:
        store.dispatch("logout").then(() => {
          router.push("/");
        });
        break;
      default:
        break;
    }
    return Promise.reject(error);
  }
);
